import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';

/**
 * Component for displaying a dialog with location information and providing functionality to download the data as an Excel file.
 * Invoked when the user clicks on the units in @see ServiceInsightsTableComponent table
 */
// TODO: Component leverages Angular Material v16 which has been deprecated.
// Consider updating to the latest version OR moving away from the library to gain more control over the UI and reduce dependency on external libraries.
@Component({
    selector: 'app-locations-dialog',
    templateUrl: './locations-dialog.component.html',
    styleUrls: ['./locations-dialog.component.scss'],
    standalone: false
})
export class LocationsDialogComponent implements OnInit {
  displayColumnsExcel: string[] = [
    'Account number',
    'Account name',
    'Address street',
    'City',
    'State',
    'Zip',
    'Country',
  ];

  dataSource: MatTableDataSource<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LocationsDialogComponent>,
  ) {
    this.dataSource = new MatTableDataSource(data.addresses);
  }

  ngOnInit(): void {}

  /**
   * Formats the location data into a structure suitable for Excel export and generates a Blob representing the Excel file.
   * @param data location data as seen in the table
   * @param columns list of columns to be included in the Excel file
   * @returns blob representing the Excel file containing the formatted location data
   */
  private convertToExcel(data: any[], columns: string[]): Blob {
    const excelData = data.map((item) => {
      return {
        'Account number': item.accountNumber,
        'Account name': item.accountName,
        'Address street': item.shippingStreet,
        City: item.shippingCity,
        State: item.shippingState,
        Zip: item.shippingPostalCode,
        Country: item.shippingCountry,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData, { header: columns });
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    return new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  }

  /**
   * Downloads the location data as an Excel file.
   */
  downloadAsExcel() {
    const excelData = this.convertToExcel(
      this.dataSource.data,
      this.displayColumnsExcel,
    );
    const url = window.URL.createObjectURL(excelData);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'locations.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
